var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8451 1.74951H20.7638C10.5431 1.74951 2.25757 10.0078 2.25757 20.195V49.3978C2.25757 59.585 10.5431 67.8433 20.7638 67.8433H49.8451C60.0658 67.8433 68.3513 59.585 68.3513 49.3978V20.195C68.3513 10.0078 60.0658 1.74951 49.8451 1.74951Z",
    fill: "#7BC8B1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4436 20.0385C55.6349 19.2297 54.3237 19.2297 53.5148 20.0385L28.7037 44.8498L19.1667 35.3129C18.358 34.5041 17.0468 34.5041 16.2379 35.3129C15.4291 36.1216 15.4291 37.4327 16.2379 38.2415L27.2393 49.2427C28.0478 50.0515 29.3599 50.0509 30.1681 49.2427L56.4436 22.9672C57.2524 22.1585 57.2523 20.8473 56.4436 20.0385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_1643",
    x: 0.257568,
    y: 0.749512,
    width: 70.094,
    height: 70.0938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_1643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_1643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_1643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4188,
    height: 41.4188,
    fill: "white",
    transform: "translate(15.6313 13.9312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.c8721b3b7030ad79ed8b811126856063.svg";
export { ForwardRef as ReactComponent };